module.exports = __webpack_public_path__ + "img/result.2830b15b.png";